import React from "react";
import {Box} from "@mui/material";
import {alpha, useTheme} from "@mui/material/styles";
import {AppTab, AppTabs} from "../Theme/CustomComponent";
import {Package} from "lucide-react";

const PalletIcon = (props) => (
    <svg
        viewBox="0 0 512 512"
        fill="currentColor"
        width="1em"
        height="1em"
        {...props}
    >
        <g>
            <path d="m497 362h-16c0-8.535 0-338.954 0-347 0-8.284-6.716-15-15-15-11.847 0-408.153 0-420 0-8.284 0-15 6.716-15 15v180 167h-16c-8.284 0-15 6.716-15 15v120c0 8.284 6.716 15 15 15h60c8.284 0 15-6.716 15-15v-45h121v45c0 8.284 6.716 15 15 15h60c8.284 0 15-6.716 15-15v-45h121v45c0 8.284 6.716 15 15 15h60c8.284 0 15-6.716 15-15 0-14.518 0-105.386 0-120 0-8.284-6.716-15-15-15zm-226 0v-152h45v45c0 8.284 6.716 15 15 15h60c8.284 0 15-6.716 15-15v-45h45v152zm75-152h30v30h-30zm105-30h-180v-150h45v45c0 8.284 6.716 15 15 15h60c8.284 0 15-6.716 15-15v-45h45zm-105-150h30v30h-30zm-210 0h30v30h-30zm-30 0v45c0 8.284 6.716 15 15 15h60c8.284 0 15-6.716 15-15v-45h45v150h-180v-150zm30 180h30v30h-30zm-75 0h45v45c0 8.284 6.716 15 15 15h60c8.284 0 15-6.716 15-15v-45h45v152h-180zm-31 182h452v30h-452zm30 90h-30v-30h30zm211 0h-30v-30h30zm181 0v-30h30v30z"/>
        </g>
    </svg>
);

const OPTIONS = [{value: "package", label: "Package"}, {value: "ltl", label: "LTL"}];

export const TrackingTypeSelector = ({value, onChange, variant = "pill"}) => {
    const theme = useTheme();
    // return (
    //     <Box
    //         role="group"
    //         aria-label="Tracking type"
    //         sx={{
    //             display: "inline-flex",
    //             width: "auto",
    //             backgroundColor: alpha(theme.palette.neutral[200], 0.28),
    //             p: 0.25,
    //             borderRadius: `${theme.shape.lg}px`,
    //             border: 1,
    //             borderColor: "divider",
    //         }}
    //     >
    //         {OPTIONS.map((option) => {
    //             const isSelected = value === option.value;
    //             return (
    //                 <Box
    //                     key={option.value}
    //                     component="button"
    //                     type="button"
    //                     aria-pressed={isSelected}
    //                     onClick={() => onChange(option.value)}
    //                     sx={{
    //                         border: "none",
    //                         cursor: "pointer",
    //                         borderRadius: `${theme.shape.md}px`,
    //                         px: 1.5,
    //                         minWidth: {xs: 108, sm: 0},
    //                         minHeight: {xs: 44, sm: 36},
    //                         fontSize: theme.typography.subtitle2.fontSize,
    //                         lineHeight: theme.typography.subtitle2.lineHeight,
    //                         fontWeight: theme.typography.subtitle2.fontWeight,
    //                         fontFamily: "inherit",
    //                         backgroundColor: isSelected ? "background.paper" : "transparent",
    //                         color: isSelected ? "text.primary" : "text.secondary",
    //                         boxShadow: isSelected ? "0 1px 2px rgba(15, 23, 42, 0.08)" : "none",
    //                         transition: "background-color 150ms ease, color 150ms ease, box-shadow 150ms ease",
    //                         display: "flex",
    //                         flex: "initial",
    //                         justifyContent: "center",
    //                         alignItems: "center",
    //                         gap: 0.5,
    //                         "&:focus-visible": {outline: `2px solid ${theme.palette.primary.main}`, outlineOffset: 1},
    //                     }}
    //                 >
    //                     <Box aria-hidden="true" sx={{width: 6, height: 6, borderRadius: "50%", backgroundColor: isSelected ? "primary.main" : "transparent"}} />
    //                     {option.label}
    //                 </Box>
    //             );
    //         })}
    //     </Box>
    // );

    if (variant === "line") {
        return (
            <AppTabs
                value={value}
                onChange={(_, newValue) => onChange(newValue)}
                aria-label="Tracking type"
                sx={{
                    borderBottom: '1px solid',
                    borderColor: 'divider',
                    width: '100%',
                }}
            >
                <AppTab
                    value="ltl"
                    label="LTL"
                    icon={<PalletIcon />}
                />
                <AppTab
                    value="package"
                    label="Package"
                    icon={<Package size={18} strokeWidth={2.1} />}
                />
            </AppTabs>
        );
    }

    return (
        <Box
            role="group"
            aria-label="Tracking type"
            sx={{
                display: "inline-flex",
                width: "auto",
                backgroundColor: alpha(theme.palette.neutral[200], 0.28),
                p: 0.25,
                borderRadius: `${theme.shape.lg}px`,
                border: 1,
                borderColor: "divider",
            }}
        >
            {OPTIONS.map((option) => {
                const isSelected = value === option.value;
                return (
                    <Box
                        key={option.value}
                        component="button"
                        type="button"
                        aria-pressed={isSelected}
                        onClick={() => onChange(option.value)}
                        sx={{
                            border: "none",
                            cursor: "pointer",
                            borderRadius: `${theme.shape.md}px`,
                            px: 1.5,
                            minWidth: {xs: 108, sm: 0},
                            minHeight: {xs: 44, sm: 36},
                            fontSize: theme.typography.subtitle2.fontSize,
                            lineHeight: theme.typography.subtitle2.lineHeight,
                            fontWeight: theme.typography.subtitle2.fontWeight,
                            fontFamily: "inherit",
                            backgroundColor: isSelected ? "background.paper" : "transparent",
                            color: isSelected ? "text.primary" : "text.secondary",
                            boxShadow: isSelected ? "0 1px 2px rgba(15, 23, 42, 0.08)" : "none",
                            transition: "background-color 150ms ease, color 150ms ease, box-shadow 150ms ease",
                            display: "flex",
                            flex: "initial",
                            justifyContent: "center",
                            alignItems: "center",
                            gap: 0.5,
                            "&:focus-visible": {outline: `2px solid ${theme.palette.primary.main}`, outlineOffset: 1},
                        }}
                    >
                        <Box aria-hidden="true" sx={{width: 6, height: 6, borderRadius: "50%", backgroundColor: isSelected ? "primary.main" : "transparent"}} />
                        {option.label}
                    </Box>
                );
            })}
        </Box>
    );
};
